import React from "react";
import "./PartnerStepIndicator.css";

const STEPS = [
  { id: 1, key: "phone", label: "Phone Number" },
  { id: 2, key: "otp", label: "OTP Verification" },
  { id: 3, key: "basic", label: "Basic Details" },
  { id: 4, key: "location", label: "Location Information" },
  { id: 5, key: "service", label: "Select Service" },
  { id: 6, key: "plan", label: "Select Plan" },
  { id: 7, key: "seats_promo", label: "Seats & Promo" },
  { id: 8, key: "review", label: "Review Order" },
];

export const PartnerStepIndicator = ({ currentStepIndex = 1 }) => {
  const currentStep = STEPS[currentStepIndex - 1] || STEPS[0];
  const totalSteps = STEPS.length;

  return (
    <div className="partner-stepper">
      <div className="partner-stepper__header">
        <span className="partner-stepper__badge">
          Step {currentStepIndex} of {totalSteps}
        </span>
        <span className="partner-stepper__title">{currentStep.label}</span>
      </div>

      <div
        className="partner-stepper__bars"
        role="progressbar"
        aria-valuenow={currentStepIndex}
        aria-valuemin={1}
        aria-valuemax={totalSteps}
      >
        {STEPS.map((step, idx) => {
          const stepNum = idx + 1;
          const isCompleted = stepNum < currentStepIndex;
          const isCurrent = stepNum === currentStepIndex;

          return (
            <div
              key={step.id}
              className={`partner-stepper__bar ${
                isCompleted
                  ? "partner-stepper__bar--completed"
                  : isCurrent
                  ? "partner-stepper__bar--active"
                  : "partner-stepper__bar--pending"
              }`}
              title={`Step ${stepNum}: ${step.label}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PartnerStepIndicator;
